import { useEffect, useState } from 'react';

import { isDesktop, isMobile } from 'react-device-detect';

import { motion, AnimatePresence } from 'framer-motion';

export const CheckDevice = () => {
	useEffect(() => {
		// Device check
		let deviceType = null;
		if (isMobile) deviceType = 'is-mobile';
		else if (isDesktop) deviceType = 'is-online';
		document.body.classList.add(deviceType);
	}, []);
};

// move scroll top
export const ScrollTop = () => {
	const [scrollPosition, setScrollPosition] = useState(0);

	useEffect(() => {
		function updatePosition() {
			setScrollPosition(window.pageYOffset);
		}

		window.addEventListener('scroll', updatePosition);

		return () => window.removeEventListener('scroll', updatePosition);
	}, []);

	function goToTop() {
		document.documentElement.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	}

	return (
		<AnimatePresence>
			{scrollPosition > 50 && (
				<motion.button
					onClick={goToTop}
					className="scroll-btn scroll-top-btn"
					initial={{ y: 50, opacity: 0, scale: 0.5 }}
					animate={{
						y: 0,
						opacity: 1,
						scale: 1,
						transition: { duration: 0.4 },
					}}
					exit={{
						y: 50,
						opacity: 0,
						scale: 0.5,
						transition: { duration: 0.4 },
					}}
					// whileHover={{
					// 	scale: 1.2,
					// 	transition: { duration: 0.2 },
					// }}
					whileTap={{ scale: 1 }}
				>
					<span></span>
					<em className="sr-only">화면 맨위로 이동</em>
				</motion.button>
			)}
		</AnimatePresence>
	);
};

// move scroll bottom
export const ScrollBottom = () => {
	const boundaryHeight = 80;
	const [reachedBottom, setReachedBottom] = useState(boundaryHeight);

	useEffect(() => {
		const handleScroll = () => {
			const offsetHeight = document.documentElement.offsetHeight;
			const innerHeight = window.innerHeight;
			const scrollTop = document.documentElement.scrollTop;

			const hasReachedBottom = offsetHeight - (innerHeight + scrollTop);

			setReachedBottom(hasReachedBottom);
		};

		window.addEventListener('scroll', handleScroll);

		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	function goToBottm() {
		document.documentElement.scrollTo({
			top: document.documentElement.offsetHeight,
			behavior: 'smooth',
		});
	}

	return (
		<AnimatePresence>
			{reachedBottom >= boundaryHeight && (
				<motion.button
					onClick={goToBottm}
					className="scroll-btn scroll-bottom-btn"
					initial={{ y: -50, opacity: 0, scale: 0.5, rotate: 180 }}
					animate={{
						y: 0,
						opacity: 1,
						scale: 1,
						transition: { duration: 0.4 },
					}}
					exit={{
						y: -50,
						opacity: 0,
						scale: 0.5,
						transition: { duration: 0.4 },
					}}
					// whileHover={{
					// 	scale: 1.2,
					// 	transition: { duration: 0.2 },
					// }}
					whileTap={{ scale: 1 }}
				>
					<span></span>
					<em className="sr-only">화면 하단으로 이동</em>
				</motion.button>
			)}
		</AnimatePresence>
	);
};
